const SUBSCRIBED = 'subscribe'
const UNSUBSCRIBED = null

export default {
  SUBSCRIBED,
  UNSUBSCRIBED
}
